/** @typedef {(data: unknown) => unknown} Subscriber */

/** @type {Record<string, Subscriber[]>} */
let subscribers = {};

/**
 * @param {string} eventName
 * @param {Subscriber} callback
 * @returns {() => void}
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

/**
 * @param {string} eventName
 * @param {unknown} data
 * @returns {Promise<unknown[] | void>}
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
